import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import {AuthHttp} from 'angular2-jwt';
import { Observable }     from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import {tokenNotExpired} from 'angular2-jwt';

import {AppSettings} from '../app-settings';

import 'rxjs/add/operator/catch';
import 'rxjs/observable/throw';

@Injectable()
export class CountryService {

  public token: string;

  headers = new Headers({'Accept': 'application/json'});
  options = new RequestOptions({headers: this.headers});

  constructor(private http: Http, private authHttp: AuthHttp) {
   var currentUser = JSON.parse(localStorage.getItem('currentUser'));
   this.token = currentUser && currentUser.token;
  }

  getCountries(): Observable<any> {
   return this.http.get(AppSettings.API_STARTPOINT+"/public/api/v1/country/list").map(response => response.json().countries);
  }

  getStates(countryId): Observable<any> {
   return this.http.get(AppSettings.API_STARTPOINT+"/public/api/v1/country/states",{
    params : {
     countryId:countryId
    }
   }).map(response => response.json().states);
  }

}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/common/country.service.ts